<template>
  <div class="registerView">
    <div class="registerContent" id="register">
      <img :src="icon"/>
      <div class="tips">请登录以便享受更加快捷方便的体验</div>
      <div class="data">
        <div class="dr container">
          <input type="tel" maxlength="11" v-model="userPhone" placeholder="请输入手机号码"
                 onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))">
        </div>
        <div class="dr randCode container">
          <input v-model="randCode" type="number" placeholder="请输入验证码" @keyup.enter="submit()">
          <send-btn class="sendBtn" :user-phone="userPhone" rand-type="BBS_REG"></send-btn>
        </div>
        <div class="dr container">
          <input v-model="passWord" type="password" placeholder="请输入密码">
        </div>
      </div>
      <div>
        <div class="submitBtn" @click="submit()">注册</div>
        <router-link to="/login">
          <div class="lp">已有账号，马上去登录></div>
        </router-link>
      </div>
    </div>
    <div class="loginFoot">
      <div>广州市中渠传媒广告有限公司 版权所有</div>
      <div><a href="https://beian.miit.gov.cn">粤ICP备12059610号-3</a></div>
      <div>
        <img :src="beiAn"/>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102001129" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44011102001129号</p></a>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '../../common/js/types'
import sendBtn from '../common/sendBtn.vue'
export default {
  components: {
    sendBtn
  },
  name: 'register',
  data () {
    return {
      icon: require('../../assets/icon/logo.png'),
      beiAn: require('../../assets/image/beian.png'),
      userPhone: '',
      randCode: '',
      userName: '',
      passWord: ''
    }
  },
  computed: {
  },
  mounted: function (s) {
    if (this.$route.params && this.$route.params.redirect) {
      localStorage.redirect = this.$route.params.redirect
    }
  },
  methods: {
    submit: function () {
      let that = this
      that.loading = true
      that.axios.post('/register', {
        userPhone: that.userPhone,
        randCode: that.randCode,
        passWord: that.passWord
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.loading = false
        if (response.data.status === 0) {
          that.$store.commit(types.LOGIN, response.data.value)
          that.$store.commit('setToastMsg', '注册成功')
          let redirect = decodeURIComponent(localStorage.redirect || '/')
          that.$router.push({
            path: redirect
          })
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        console.log(response)
        that.loading = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {}
}
</script>
<style scoped>
.registerView{
  background-color: #FBFBFB;
  padding-bottom: 20px;
  border-top: 1px solid #F0F0F0;
  padding-top: 110px;
}
.registerContent {
  width: 300px;
  margin: 0 auto;
}
.tips {
  font-size: 16px;
  margin: 15px 0 40px 0;
}
.data{
  text-align: center;
  width: 300px;
  font-size: 18px;
}
.data .dr {
  width: 300px;
  margin-bottom: 10px;
}
.data .dr input{
  height: 40px;
  width: 100%;
  outline: 0;
  font-size: 14px;
  text-indent: 1em;
  border: 1px solid #F0F0F0;
}
.randCode input{
  width: 180px !important;
  float: left;
}
.submitBtn{
  margin: 25px 0 15px 0;
  font-size: 20px;
  background-color: #06B570;
  color: white;
  height: 40px;
  line-height: 40px;
  width: 300px;
}
.lp {
  font-size: 12px;
  float: right;
  color: #06B570;
}
.loginFoot {
  font-size: 12px;
  width: 600px;
  margin: 0 auto;
  margin-top: 220px;
  padding-bottom: 20px;
}
.loginFoot div {
  float: left;
  padding: 0 10px;
}
</style>
<style>
  #register .sendBtn{
    width: 96px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    margin: 0;
    margin-left: 12px;
    background-color: #06B570;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/register.vue